const leituraRoutes = [
  {
    path: '/leituras',
    name: 'leituras-dashboard',
    component: () => import('@/views/leitura/Dashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Leituras', active: true },
      ],
    },
  },
  {
    path: '/leitura/new',
    name: 'leitura-view',
    component: () => import('@/views/leitura/LeituraEdit.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Leituras', url: '/leituras' },
        { title: 'Nova', active: true },
      ],
    },
  },
  {
    path: '/leitura/:id',
    name: 'leitura-view',
    component: () => import('@/views/leitura/LeituraEdit.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Leituras', url: '/leituras' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
]

export default leituraRoutes
